<!--  -->
<template>
<div class="bac">
  <div class="logo-box">
    <a href="/" class="logo" title="测评系统"><img :src="`/static/img/logo.jpg?t=${Math.random()}`" alt="logo"></a>
    <!-- <el-button  @click="$router.push('/')" class="personcenter" round >首页</el-button> -->
  </div>
  <div class="logo-form">
    <div class="logo-tip">
        <h3>一体化岗位领域人才能力培养测评服务平台</h3>
        <span>注意事项</span>
        <p>1、本平台独立运营，请勿使用其他平台 (网校)的账号</p>
        <p>2、仅带有摄像头标识的考场，登录后需调试摄像头。未含摄像头标识的考场，无需启动摄像头。</p>
        <p>3、报名成功的参测人员可通过请关注公众号“人才测评网”，获取测评账号及登录密码。</p>
        <p>4、如登录提示“该手机号已被其他用户绑定”，表示此手机号被他人占用，可联系报名</p>
        <div class="codenum">
          <div class="code-img">
              <img src="/static/img/recode.png" width="86" alt="">
          </div>
          <div class="code-tip">
            <span>温馨提示：</span>
            <p>关注微信公众号<br>查询账号及成绩</p>
          </div>
        </div>
    </div>
    <div class="login">
        <div class="login-logo">
            统一测评学习系统
        </div>
        <div class="login-form">
            <div style="padding-left:52px;">
                <div class="input-group">
                    <el-input placeholder="请输入登录账号" v-model="loginUser.identificationcard" >
                      <template slot="prepend">
                            <img src="/static/img/geren.png" alt="">
                        </template>
                    </el-input>
                </div>
                <div class="input-group">
                    <el-input placeholder="请输入登录密码" v-model="loginUser.password" show-password>
                      <template slot="prepend">
                      <img src="/static/img/suousouso.png" alt="">
                      </template>
                    </el-input>
                </div>
                <button type="button" id="login" class="btn btn-success btn-block"  @click="submitForm()" >登录</button>
            </div>
        </div>
        <!-- <div class="login-regist">
          <input type="checkbox"  id="brand1" v-model="checked" >
              <label for="brand1"><span></span>记住我的登录信息</label>
      </div> -->
      
    </div>
  </div>
    <!-- <footer-nav/> -->
</div>

</template>
<script>
import jwt_decode from "jwt-decode";
import global from "../components/PublicComs/Common.vue";
import { Message } from "element-ui";
// import FooterNav from '../components/HomeComs/FooterNav.vue';
const rate= window.innerWidth/1920;
export default {
      metaInfo: {
       meta: [
        { name:'viewport', content:
        `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
      ]
    },
  data() {
    return {
      loginUser: {
        password: "",
        identificationcard: "",
        yzcode: "",
        yzmsrc: "",
      },
      global,
      webConfig: {},
      checked: false,
    };
  },

  // components: {FooterNav},

  computed: {},

  mounted() {
    this.$axios.get("/api/webConfigs").then((res) => {
      if (res.data && res.data.data.length > 0) {
        this.webConfig = res.data.data[0];
      }
    });
    this.getImgVerify();
    this.getCookie();
    window.addEventListener("keydown", this.keyDown);
  },
  methods: {
    submitForm() {
      if (!this.loginUser.password) {
        Message.error("密码不能为空！");
        return;
      } else if (!this.loginUser.identificationcard) {
        Message.error("身份证号码不能为空！");
        return;
      }
      this.$axios.post("/api/auth/login", this.loginUser).then((res) => {
        // 登录成功
        const self = this;
        //判断复选框是否被勾选 勾选则调用配置cookie方法
        if (self.checked == true) {
          console.log("checked == true");
          //传入账号名，密码，和保存天数3个参数
          self.setCookie(
            this.loginUser.password,
            this.loginUser.identificationcard,
            30
          );
        } else {
          console.log("清空Cookie");
          //清空Cookie
          self.clearCookie();
          self.setCookie(this.loginUser.password, "", 30);
        }
        const { token } = res.data;
        localStorage.setItem("eleTokenWrd001", token);

        // 解析token
        const decode = jwt_decode(token);
        // 存储数据
        this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
        this.$store.dispatch("setUser", decode);
        //获取购买的课程
          let arrhasCourse = [];
          for (var i = 0; i <res.data.data.needexaminee.length; i++)
          {
            arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
          }
          this.$root.hasCourse =arrhasCourse;
        this.$root.ischeckface = res.data.data.ischeckface;
        this.$root.onlymycourse = res.data.data.onlymycourse;
        this.$root.buytype = res.data.data.buytype;
        if( res.data.data.onlymycourse)
            localStorage.setItem("onlymycourseWrd", "1");
        else
          localStorage.setItem("onlymycourseWrd", "0");
        localStorage.setItem("hasCourseWrd", arrhasCourse.join(","));
        // 页面跳转
        this.$router.push("/");
      });
    },
    getImgVerify() {
      this.loginUser.yzmsrc =
        `${this.global.remoteIp}/api/auth/imgverify` + "?" + Math.random();
    },
    keyDown(e) {
      //如果是按回车则执行登录方法
      if (e.keyCode == 13) {
        this.submitForm();
      }
    },
    //设置cookie
    setCookie(c_name, c_id, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "stuName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      if (c_id) {
        window.document.cookie =
          "stuId" + "=" + c_id + ";path=/;expires=" + exdate.toGMTString();
      }
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "stuName") {
            this.loginUser.password = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "stuId") {
            this.loginUser.identificationcard = arr2[1];
            this.checked = true;
          }
        }
      }
    },
    isEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      );
    },
    //清除cookie
    clearCookie: function() {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
  },
};
</script>
<style lang="scss" scoped>
.bac{
  width: 100%;
  height: 1080px;
background: url("/static/img/denglebgg.png");
background-repeat: no-repeat;
background-position: center;
background-size: auto 1080px;
}
.logo-form{
  width: 1132px;
  height: 648px;
  margin:0 auto;
}
.login-logo{
  margin: 78px auto 96px;
  position: relative;
width: 566px;
height: 35px;
font-size: 35px;
font-family: PingFang SC;
font-weight: bold;
color: #252626;
line-height: 35px;
text-align: center;
}
.login-logo::after{
  content: '';
  position: absolute;
  top:64px;
  left: 264px;
  width: 38px;
  height: 8px;
  
background: #4462CF;
  border-radius: 3px;
}
.login{
  float: right;
  width: 566px;
height: 648px;
background: #FFFFFF;
box-shadow: 0px 12px 51px 0px rgba(68,98,207,0.19);
border-radius: 0px 5px 5px 0px;
}
.logo-tip{
float: left;
  width: 566px;
height: 648px;
background: #FFFFFF;
opacity: 0.79;
border-radius: 5px 0px 0px 5px;
padding: 85px 52px 0 52px;
display: flex;
flex-direction: column;
justify-content: start;
align-items: start;
}
.logo-tip h3{
height: 22px;
font-size: 22px;
font-family: PingFang SC;
font-weight: bold;
color: #4462CF;
line-height: 22px;
text-align: center;
}
.logo-tip span{
  width: 100%;
  margin-top: 29px;
  margin-bottom: 45px;
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #4462CF;
  line-height: 16px;
  text-align: center;
}
.logo-tip>p{
  margin-bottom: 23px;
  margin-left: 11px;
  width: 426px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
line-height: 28px;
}
.logo-tip .codenum{
  border-top:1px solid RGBA(68, 98, 207, 0.2);
  width: 439px;
  padding: 35px 102px 0 102px;
}
.codenum .code-img{
  float: left;
  width: 88px;
  height: 88px;
  bottom: 2px solid #fff;
  margin-right: 25px;
}
.codenum .code-tip{
  float: left;
  height: 80px;
  padding-top: 4px;
  span{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #E32D2D;
    line-height: 16px;
  }
  p{
    padding-top: 24px;
    width: 112px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #4462CF;
    line-height: 16px;
  }
}
.input-group{
  position: relative;
  background: #F2F4F9;
  height: 67px;
  margin-bottom: 42px;
  width: 464px;
border-radius: 5px;
overflow: hidden;
}
.input-group::before{
  position: absolute;
  content: '';
  top:21px;
  left: 73px;
  width: 1.5px;
height: 25px;
background: #E3E6EF;
z-index: 1;
}
.input-group >>>input.el-input__inner{
  height: 67px;
  font-size: 21px;
font-family: PingFang SC;
font-weight: 400;
color: #666;
line-height: 67px;
background: #F2F4F9 !important;
border: 0;
}
::v-deep {
  .el-input__inner {
    &::placeholder {
      color: #9BA1A8;
    }
  }
} 
.input-group >>>.el-input--suffix{
    background: #F2F4F9;
}
.input-group >>>.el-input-group__prepend{
  width: 74px;
  text-align: center;
  background: #F2F4F9;
  border: 0;
}
.input-group >>>.el-input{
height: 67px;
background: #F2F4F9;
border: 0;
}
#login{
  margin-top: 108px;
  width: 464px;
height: 67px;
background: #4462CF;
border-radius: 5px;
font-size: 29px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 55px;
}
</style>
